import React from 'react'
import routes from '../config/settings/routes'
import { DownloadsNavProvider } from '../components/Navigation/DownloadsNavButton.context'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import DownloadsLayout from '../components/Layouts/DownloadsLayout'
import CantFindDataFormContainer from '../containers/CantFindDataForm/CantFindDataForm.container'
import DownloadFrameworkSectionContainer from '../containers/DownloadFrameworkSection/DownloadFrameworkSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import NotFoundPage from './NotFound'

/**
 * The DownloadFramework's page.
 */
const DownloadFramework = () => {
  return (
    <ProtectByFeatures
      fallback={() => <NotFoundPage />}
      rule={features => features['cl.chilecompra.datos-abiertos/downloads-page']}
    >
      <BrandLayout footer={<FooterContainer margin="0" />}>
        <TopNavbarContainer menuActive={routes.downloads} />
        <SearchBuyerPanelContainer />
        <DownloadsNavProvider>
          <DownloadsLayout menuActive={routes.downloadFramework}>
            <DownloadFrameworkSectionContainer />
          </DownloadsLayout>
        </DownloadsNavProvider>
        <CantFindDataFormContainer />
      </BrandLayout>
    </ProtectByFeatures>
  )
}

export default DownloadFramework
